module.exports = __webpack_public_path__ + "live-join-wx-368c013c.png";